import React from 'react';

const Search = (props: React.SVGProps<SVGSVGElement>): React.ReactElement => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" {...props}>
      <mask id="mask0_1360_1999" maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
        <rect width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1360_1999)">
        <path
          d="M15.9274 17.1893L10.9134 12.1752C10.5 12.4675 10.0456 12.6971 9.55019 12.8641C9.05474 13.0311 8.52494 13.1145 7.96077 13.1145C6.54151 13.1145 5.33414 12.6168 4.33867 11.6213C3.3432 10.6259 2.84546 9.41874 2.84546 7.99996C2.84546 6.58118 3.3432 5.37406 4.33867 4.37858C5.33414 3.38311 6.54126 2.88538 7.96004 2.88538C9.37882 2.88538 10.5859 3.38311 11.5814 4.37858C12.5769 5.37406 13.0746 6.58142 13.0746 8.00069C13.0746 8.56817 12.9911 9.09798 12.8242 9.59011C12.6572 10.0822 12.4276 10.5333 12.1353 10.9434L17.1543 15.9674L15.9274 17.1893ZM7.96004 11.3854C8.90238 11.3854 9.70219 11.0567 10.3595 10.3994C11.0168 9.74211 11.3455 8.94229 11.3455 7.99996C11.3455 7.05763 11.0168 6.25781 10.3595 5.6005C9.70219 4.9432 8.90238 4.61454 7.96004 4.61454C7.01771 4.61454 6.21789 4.9432 5.56058 5.6005C4.90328 6.25781 4.57463 7.05763 4.57463 7.99996C4.57463 8.94229 4.90328 9.74211 5.56058 10.3994C6.21789 11.0567 7.01771 11.3854 7.96004 11.3854Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};

export default Search;
